module.exports = __webpack_public_path__ + "img/melissa-add-pagamento.8ea727e7.png";